import React, { Component } from 'react';
import { connect } from 'react-redux';
import TablePublicReac from '../components/TablePublicReac';
import { columnsPublicReac } from '../services/config/publicReacColumnsConfig';
import { getReac, flagLoadingReac } from '../../actions/reacondicionadosActions';
import { getReacData } from '../../common/store/reducers/reacondicionados';
import SearcherPro from 'stock/components/SearcherPro';
import { filterReacDataByText } from '../services/filterReacData';

class PublicReacContainer extends Component {
    constructor() {
        super();
        this.state = { searchData: { text: '' } }
    }

    componentDidMount() {
        const { reac, getReac } = this.props;
        if (!reac || reac.length === 0) {
            getReac();
        }
    }

    handleSearchText = text => {
        this.setState({ searchData: { text } })
    }

    getAvailableData = () => {
        const { reac } = this.props;
        const all = getReacData(reac).filter(item => item.estado === 'stock');
        return filterReacDataByText(all, this.state.searchData.text);
    };

    render() {
        const { loading } = this.props;
        const { text: textSearch } = this.state.searchData;
        return (
            <div style={{ padding: '20px' }}>
                <SearcherPro
                    textSearch={textSearch}
                    handleChangeTextSearch={this.handleSearchText}
                />
                <TablePublicReac
                    loading={loading}
                    columns={columnsPublicReac}
                    data={this.getAvailableData()}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    reac: state.reacondicionados.data,
    loading: state.reacondicionados.loading,
});

const mapDispatchToProps = dispatch => ({
    getReac: () => dispatch(getReac()),
    flagLoadingReac: payload => dispatch(flagLoadingReac(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicReacContainer);
